import { calculateAspectRatio } from './calculateAspectRatio';
import type { MediaDimensions } from './types';

function getVideoDimensions(videoEl: HTMLVideoElement): MediaDimensions {
	return {
		height: videoEl.height,
		width: videoEl.width,
		intrinsicHeight: videoEl.videoHeight,
		intrinsicWidth: videoEl.videoWidth,
	};
}

function getImageDimensions(imageEl: HTMLImageElement): MediaDimensions {
	return {
		height: imageEl.height,
		width: imageEl.width,
		intrinsicHeight: imageEl.naturalHeight,
		intrinsicWidth: imageEl.naturalWidth,
	};
}

export function getVideoAspectRatio(videoEl: HTMLVideoElement): number | undefined {
	// State 1 is `HAVE_METADATA` which is when the videos dimensions should be available.
	if (videoEl.readyState < 1) {
		return undefined;
	}

	return calculateAspectRatio(getVideoDimensions(videoEl));
}

export function getImageAspectRatio(imageEl: HTMLImageElement): number | undefined {
	// We can only use the image's dimensions if loading has finished.
	if (!imageEl.complete) {
		return undefined;
	}

	return calculateAspectRatio(getImageDimensions(imageEl));
}
